import { render, staticRenderFns } from "./NumberFlippersDashboardItem.vue?vue&type=template&id=1bf37e91"
import script from "./NumberFlippersDashboardItem.vue?vue&type=script&lang=js"
export * from "./NumberFlippersDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf37e91')) {
      api.createRecord('1bf37e91', component.options)
    } else {
      api.reload('1bf37e91', component.options)
    }
    module.hot.accept("./NumberFlippersDashboardItem.vue?vue&type=template&id=1bf37e91", function () {
      api.rerender('1bf37e91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/NumberFlippersDashboardItem.vue"
export default component.exports